import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router'
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
declare var $: any, moment: any
@Component({
  selector: 'app-status-request-document',
  templateUrl: './status-request-document.component.html',
  styleUrls: ['./status-request-document.component.scss']
})
export class StatusRequestDocumentComponent implements OnInit {
  lang: string = "th-TH"
  cookieData: any
  contact: any
  contactDROS: any
  crm08DROS: any
  crm08DROSList: any = []
  combinedAddressList: any


  constructor(private router: Router, private apiService: ApiService, private util: UtilService) {

  }

  async ngOnInit() {
    this.lang = this.util.GetCurrentLang();
    let thisTs = this;

    let PortalUser: any = JSON.parse(localStorage.getItem("dpa_portal"));

    if (PortalUser == null || PortalUser.contactid == null || PortalUser.contactid == "") {
      this.util.WarningDialog("กรุณาเข้าสู่ระบบ");
      $("#btnWarningOK").off("click");
      $("#btnWarningOK").click(function () {
        thisTs.router.navigate(["/mainmenu/login"]);
      });
      return;
    }

    this.util.ShowWaiting(true)
    this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"))
    if (this.cookieData == null) {
      this.cookieData = {};
    }

    let accNo = localStorage.getItem("acccountNo");

    this.contact = await this.getContact();
    this.contactDROS = await this.getContactDROS(this.contact.dpa_idcard)
    if (!this.util.IsNullOrUndefined(this.contactDROS.CRM06)) {
      this.crm08DROS = await this.getCRM08DROS(this.contactDROS.CRM06.UID);
      if (!this.util.IsNullOrUndefined(this.crm08DROS) && this.crm08DROS.length > 0) {
        for (let itm of this.crm08DROS) {
          if (itm.DROSRequestNo == accNo){
            let docStatus: string;
            if (itm.SentStatus === "1") { docStatus = "ส่งสำเร็จ" }
            else if (itm.PrintStatus === "1") { docStatus = "อยู่ระหว่างจัดพิมพ์" }
            else if (itm.IsRead === "1") { docStatus = "ได้รับข้อมูล" }
            else { docStatus = "ยื่นคำขอเอกสารใหม่" }
            let rowDisplay: any = { CRMRequestNo: itm.CRMRequestNo, DROSRequestNo: itm.DROSRequestNo, DocumentCode: itm.DocumentCode, UID: itm.UID, Status: itm.Status, ErrorCode: itm.ErrorCode, Address: itm.Address, MooNo: itm.MooNo, StreetName: itm.StreetName, LocationCode: itm.LocationCode, Zipcode: itm.Zipcode, PhoneNo: itm.PhoneNo, Email: itm.Email, CreateOn: this.DisplayDate(itm.CreateOn), ModifiedOn: itm.ModifiedOn, ProcessStatus: docStatus };
            this.crm08DROSList.push(rowDisplay);
          }
        }
      }
    }

    this.combinedAddressList = await this.getAddressAll();

    localStorage.setItem('acccountNo', null);

    this.util.ShowWaiting(false);
  }


  async getContact() {
    let para = "contactid=" + this.cookieData.contactid;
    let tmp: any = await this.apiService.get("crmservice", "contact", para);
    return tmp[0];
  }

  async getContactDROS(idcard: string) {
    let para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=false&CRM02=false&CRM07=false";
    let tmp: any = await this.apiService.get("crmservice", "contactDros", para);
    return tmp;
  }

  async getCRM08DROS(uid: string) {
    let para = "UID=" + uid;
    let tmp: any = await this.apiService.get("crmservice", "getCRM08DROS", para);
    return tmp;
  }

  async getAddressAll() {
    let tmp: any = await this.apiService.getMasterAddress();
    return tmp;
  }

  DisplayDate(sdate: string) {
    let result: string = "";
    let enDate: string[] = sdate.split('T')[0].split('-');
    if (this.lang === "th-TH") {
      result = enDate[2] + "/" + enDate[1] + "/" + (parseInt(enDate[0]) + 543).toString();
    }
    else {
      result = enDate[2] + "/" + enDate[1] + "/" + enDate[0];
    }
    return result;
  }

  ShowDetail(drosReqNo: string) {
    let objDetail: any = this.crm08DROSList.find((e: { DROSRequestNo: string; }) => e.DROSRequestNo === drosReqNo);
    if(!this.util.IsNullOrUndefined(objDetail.ErrorMessage))
    {
      this.util.WarningDialog(objDetail.ErrorMessage); 
    }
    let addr: any = this.combinedAddressList.filter((a: any) => a.id.split('|')[0] == objDetail.LocationCode)
    $("#lblFullname").empty().text(this.contactDROS.CRM06.Name);
    $("#lblPhoneNo").empty().text(objDetail.PhoneNo);
    $("#lblDROSReqNo").empty().text(objDetail.DROSRequestNo);

    let fullAdress: string = "";
    if (!this.util.IsNullOrUndefined(objDetail.Address)) {
      fullAdress += objDetail.Address;
    }
    if (!this.util.IsNullOrUndefined(objDetail.MooNo)) {
      fullAdress += " หมู่ที่ " + objDetail.MooNo;
    }
    if (!this.util.IsNullOrUndefined(objDetail.StreetName)) {
      fullAdress += " ถนน" + objDetail.StreetName;
    }

    if(addr.length>0){
    let tmpAddr: string[] = addr[0].text.split('|');
    for (let i = 0; i < tmpAddr.length; i++) {
      if (i == 0) { fullAdress += " แขวง/ตำบล " + tmpAddr[i]; }
      if (i == 1) { fullAdress += " เขต/อำเภอ " + tmpAddr[i]; }
      if (i == 2) { fullAdress += " จังหวัด" + tmpAddr[i]; }
      if (i == 3) { fullAdress += tmpAddr[i] == objDetail.Zipcode ? " ไปรษณีย์ " + tmpAddr[i] : " ไปรษณีย์ " + objDetail.Zipcode; }
      if (i == 4) { fullAdress += " ประเทศ " + tmpAddr[i]; }
    }
  }

    $("#lblAddress").empty().text(fullAdress);


    switch (objDetail.ProcessStatus) {
      case "ส่งสำเร็จ": {
        $("#imgStatus01").attr("src", "../../assets/images/reqDocStatus01_active.png");
        $("#imgStatus02").attr("src", "../../assets/images/reqDocStatus02_active.png");
        $("#imgStatus03").attr("src", "../../assets/images/reqDocStatus03_active.png");
        break;
      }
      case "อยู่ระหว่างจัดพิมพ์": {
        $("#imgStatus01").attr("src", "../../assets/images/reqDocStatus01_active.png");
        $("#imgStatus02").attr("src", "../../assets/images/reqDocStatus02_active.png");
        $("#imgStatus03").attr("src", "../../assets/images/reqDocStatus03.png");
        break;
      }
      case "ยื่นคำขอเอกสารใหม่":
      case "ได้รับข้อมูล": {
        $("#imgStatus01").attr("src", "../../assets/images/reqDocStatus01_active.png");
        $("#imgStatus02").attr("src", "../../assets/images/reqDocStatus02.png");
        $("#imgStatus03").attr("src", "../../assets/images/reqDocStatus03.png");
        break;
      }
      default: {
        $("#imgStatus01").attr("src", "../../assets/images/reqDocStatus01.png");
        $("#imgStatus02").attr("src", "../../assets/images/reqDocStatus02.png");
        $("#imgStatus03").attr("src", "../../assets/images/reqDocStatus03.png");
        break;
      }
    }


    $("#frmStatusReqNewDoc").removeClass("animate-opacity").addClass("hideDiv");
    $("#divDetail").removeClass("hideDiv").addClass("animate-opacity");
    //console.log(objDetail);
    // console.log(this.contactDROS.CRM06);
  }

  BackToList() {
    $("#divDetail").removeClass("animate-opacity").addClass("hideDiv");
    $("#frmStatusReqNewDoc").removeClass("hideDiv").addClass("animate-opacity");

  }

  BackToReDoc() {
    
    this.router.navigate(["/mainmenu/reqNewDocument"]);

  }

}



// WEBPACK FOOTER //
// ./src/app/status-request-document/status-request-document.component.ts